import React, { useRef,useEffect,useState, useContext } from 'react'
import { Button } from 'primereact/button';     
import { InputTextarea } from 'primereact/inputtextarea';
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { InputSwitch } from "primereact/inputswitch";
import { FileUpload } from 'primereact/fileupload';
import StepsIncident from '../steps/StepsIncident';
import { Divider } from 'primereact/divider';
import { InvalidError } from '../errors/InvalidError';
import { Splitter, SplitterPanel } from 'primereact/splitter';
import { Panel } from 'primereact/panel';
import { Tag } from 'primereact/tag';
import { Timeline } from 'primereact/timeline';
import CommentForm from '../comments/CommentForm';
import DataContext from '../../context/DataContext';
import { API_URL } from '../../config/constants';
import { formatDateTime } from '../../utilities/FormatDateTime';
import { getAllComments } from '../../api/axiosComments';
import { Dialog } from 'primereact/dialog';

import IncidentForm from '../../components/incident/IncidentForm';
import { createIncident, editIncident, getAllIncidents,getSpecificIncidents } from '../../api/axiosIncidents';
import { getAllCountries } from '../../api/axiosCountries';
import { getCountryRegions} from '../../api/axiosRegions';
import { getRegionDistricts } from '../../api/axiosDistricts';
import { getDistrictWards } from '../../api/axiosWards';
import { getAllBroadCategories } from '../../api/axiosBroadCategories';
import { getBroadCategoryCategories } from '../../api/axiosCategories';
import { getCategorySubCategories } from '../../api/axiosSubCategories';
import { getBroadCategoryRights } from '../../api/axiosRights';
import { getAllEducationLevels } from '../../api/axiosEducationLevels';
import { getAllReligions } from '../../api/axiosReligions';
import { getAllVulnerabilities } from '../../api/axiosVulnerabilities';
import { getAllDisabilities } from '../../api/axiosDisabilities';
import { getAllMaritalStatuses } from '../../api/axiosMaritalStatuses';
import { getAllTribes } from '../../api/axiosTribes';
import { getAllEmploymentSectors } from '../../api/axiosEmploymentSectors';
import { getAllEmploymentStatuses } from '../../api/axiosEmploymentStatuses';
import { getAllMarriageTypes } from '../../api/axiosMarriageTypes';
import { getAllRoles } from '../../api/axiosRoles';
import IncidentActionBody from '../../components/buttonActions/IncidentActionBody';
import { getAllZones } from '../../api/axiosZones';
import { IoCompassOutline } from 'react-icons/io5';
import { getNotifications } from '../../api/axiosNotifications';
import ResponseForm from '../comments/ResponseForm';
import { getAllResponses } from '../../api/axiosResponses';















        

const IncidentViewForm = (

  { 
    incidentTitle, setViewDialogVisible,incidentValidity,
    ICNrowData, iconsdisabled,handleAllToasts,fetchIncidents,monitorNotification
  }

 

) => {


  const {
    fetcherror, setFetcherror,
    countries, setCountries,
    regions, setRegions,
    districts, setDistricts,
    wards, setWards,
    broadCategories, setBroadCategories,
    categories, setCategories,
    subCategories, setSubCategories,
    rights, setRights,
    religions, setReligions,
    tribes, setTribes,
    educationLevels, setEducationLevels,
    employmentStatuses, setEmploymentStatuses,
    employmentSectors, setEmploymentSectors,
    maritalStatuses, setMaritalStatuses,
    marriageTypes, setMarriageTypes,
    vulnerabilities, setVulnerabilities,
    disabilities, setDisabilities,
    roles, setRoles, auntheticatedUser,
    notifications, setNotifications,
    isLoadingNotifications, setIsLoadingNotifications,
    fetcherrorNotifications, setFetcherrorNotifications
    
  
  } = useContext(DataContext);

  const fileUploadRef = useRef(null);

  // Incident Edit.
  const fileBrowseOption1 = <span><i className="pi pi-upload" style={{ fontSize: '1rem' }}></i> &nbsp; Choose the File to Upload</span>
  const [editDialogVisible, setEditDialogVisible] = useState(false);
  const [fistNameReporter, setFistNameReporter] = useState("");
  const [lastNameReporter, setLastNameReporter] = useState("");
  const [selectedReporterRole,setSelectedReporterRole] = useState("");
  const [phoneReporter, setPhoneReporter] = useState("");
  const [emailReporter, setEmailReporter] = useState("");
  const [selectedSexReporter, setSelectedSexReporter] = useState("");

  const [incidentDescription, setIncidentDescription] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("TANZANIA");
  const [selectedRegion, setSelectedRegion] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedWard, setSelectedWard] = useState("");
  const [street, setStreet] = useState("");
  const [eventDate, setEventDate] = useState("");
  const [selectedBroadCategory, setSelectedBroadCategory] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedSubCategory, setSelectedSubCategory] = useState("");
  const [selectedRight, setSelectedRight] = useState("");
  const [stepsTaken, setStepsTaken] = useState(false);
  const [stepsDescription, setStepsDescription] = useState("");

  const [fistNameVictim, setFistNameVictim] = useState("");
  const [middleNameVictim, setMiddleNameVictim] = useState("");
  const [lastNameVictim, setLastNameVictim] = useState("");
  const [selectedSexVictim, setSelectSetSexVictim] = useState("");
  // const [emailVictim, setEmailVictim] = useState("");
  const [selectedBirthDayVictim, setSelectedBirthDayVictim] = useState("");
  const [selectedBirthMonthVictim, setSelectedBirthMonthVictim] = useState("");
  const [birthYearVictim, setBirthYearVictim] = useState("");
  const [phoneVictim, setPhoneVictim] = useState("");
  const [selectedEducationLevelVictim, setESelectedEducationLevelVictim] = useState("");
  const [selectedReligionVictim, setSelectedReligionVictim] = useState("");
  const [selectedTribeVictim, setSelectedTribeVictim] = useState("");
  const [childrenVictim, setChildrenVictim] = useState("");
  const [selectedMaritalStatusVictim, setSelectedMaritalStatusVictim] = useState("");
  const [selectedMarriageTypeVictim, setSelectedMarriageTypeVictim] = useState("");
  const [selectedEmploymentStatusVictim, setSelectedEmploymentStatusVictim] = useState("");
  const [selectedEmploymentSectorVictim, setSelectedEmploymentSectorVictim] = useState("");
  const [isVictimVulnerable, setIsVictimVulnerable] = useState(false);
  const [selectedVulnerabilityVictim, setSelectedVulnerabilityVictim] = useState("");
  const [isDisabled,setIsDisabled] = useState(false);
  const [selectedDisabilityVictim, setSelectedDisabilityVictim] = useState("");


  const [fullNamePerpetrator, setFullNamePerpetrator] = useState("");
  const [selectedSexPerpetrator, setSelectedSexPerpetrator] = useState("");
  const [phonePerpetrator, setPhonePerpetrator] = useState("");
  const [relationship, setRelationship] = useState("");
  const [assitanceNeeded, setAssitanceNeeded] = useState(false);
  const [assitanceDescription, setAssitanceDescription] = useState("");
  const [files, setFiles] = useState(null);
  const [zones, setZones] = useState([]);
  const [selectedZone, setSelectedZone] = useState("");

  const [validity, setValidity] = useState(true);

  const [updateSelectorVisible, setUpdateSelectorVisible] = useState(false);
  const [responseDialogVisible, setResponseDialogVisible] = useState(false);
  const [responses, setResponses] = useState([]);

  const [discardDialogVisible, setDiscardDialogVisible] = useState(false);




  const [incidentstatus, setIncidentstatus] = useState("");

  const user_id = auntheticatedUser?.id;
  const EditDialogHeader = (<div className='text-center mb-0'>Edit Incident</div>);
  
  const createDaysArray =() => { 
    const daysArray = [];
      for (let i = 1; i <= 31; i++) {
        const dayValue = i < 10 ? "0" + i : "" + i;
        const dayObject = { day: dayValue, stringValue:dayValue };
        daysArray.push(dayObject);
    }
    return daysArray;
  }
  const daysArray = createDaysArray();

  const monitorinitiated =  (auntheticatedUser?.role === "Admin" || auntheticatedUser?.role === "Operator" || auntheticatedUser?.role === "LHRCstaff") ? false:true 
  
  


  const createMonthArray = () => {
    const monthsArray = [];
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    
    for (let i=0; i < 12; i++) { 
      let value;
      if (i < 9) { value = "0" + (i + 1); } else { value = (i+1).toString(); }
      let monthsObject = { month: months[i], stringValue: value }
      monthsArray.push(monthsObject);
    }
    return monthsArray;
  }


  const extractIndividualDates = (birthdate) => {
    const newArray = birthdate.split('-');
    return newArray
  }

  const monthsArray = createMonthArray();

  const operatorinitiated = true;
  const hadleSubmit=() => {
    editIncident(
      ICNrowData.id,
      fistNameReporter, setFistNameReporter,
      lastNameReporter, setLastNameReporter,
      selectedReporterRole,setSelectedReporterRole,
      phoneReporter, setPhoneReporter,
      emailReporter, setEmailReporter,
      selectedSexReporter, setSelectedSexReporter,
      incidentDescription, setIncidentDescription,
      selectedCountry, setSelectedCountry,
      selectedRegion, setSelectedRegion,
      selectedDistrict, setSelectedDistrict,
      selectedWard, setSelectedWard,
      street, setStreet,
      eventDate, setEventDate,
      selectedBroadCategory, setSelectedBroadCategory,
      selectedCategory, setSelectedCategory,
      selectedSubCategory, setSelectedSubCategory,
      selectedRight, setSelectedRight,
      stepsTaken, setStepsTaken,
      stepsDescription, setStepsDescription,
  
      fistNameVictim, setFistNameVictim,
      middleNameVictim, setMiddleNameVictim,
      lastNameVictim, setLastNameVictim,
      selectedSexVictim, setSelectSetSexVictim,
      selectedBirthDayVictim, setSelectedBirthDayVictim,
      selectedBirthMonthVictim, setSelectedBirthMonthVictim,
      birthYearVictim, setBirthYearVictim,
      phoneVictim, setPhoneVictim,
      selectedEducationLevelVictim, setESelectedEducationLevelVictim,
      selectedReligionVictim, setSelectedReligionVictim,
      selectedTribeVictim, setSelectedTribeVictim,
      childrenVictim, setChildrenVictim,
      selectedMaritalStatusVictim, setSelectedMaritalStatusVictim,
      selectedMarriageTypeVictim, setSelectedMarriageTypeVictim,
      selectedEmploymentStatusVictim, setSelectedEmploymentStatusVictim,
      selectedEmploymentSectorVictim, setSelectedEmploymentSectorVictim,
      isVictimVulnerable, setIsVictimVulnerable,
      selectedVulnerabilityVictim, setSelectedVulnerabilityVictim,
      isDisabled,setIsDisabled,
      selectedDisabilityVictim, setSelectedDisabilityVictim,
      fullNamePerpetrator, setFullNamePerpetrator,
      selectedSexPerpetrator, setSelectedSexPerpetrator,
      phonePerpetrator, setPhonePerpetrator,
      relationship, setRelationship,
      assitanceNeeded, setAssitanceNeeded,
      assitanceDescription, setAssitanceDescription,
      files, setFiles,validity,
      setFetcherror,
      handleAllToasts,
      handleFileUpload,
      operatorinitiated,
      fetchIncidents,setEditDialogVisible,monitorNotification,setViewDialogVisible,
      (err, data) => {
        if (data) {
          getNotifications(setNotifications, setIsLoadingNotifications, setFetcherrorNotifications, operatorinitiated? undefined: auntheticatedUser.id);
        }
      }
    );
  }


  

useEffect(() => { 
  getAllCountries(setCountries, setFetcherror);
  getAllRoles(setRoles, setFetcherror)
  getAllBroadCategories(setBroadCategories, setFetcherror);
  getAllEducationLevels(setEducationLevels, setFetcherror);
  getAllReligions(setReligions, setFetcherror);
  getAllTribes(setTribes, setFetcherror);
  getAllMaritalStatuses(setMaritalStatuses, setFetcherror);
  getAllVulnerabilities(setVulnerabilities, setFetcherror);
  getAllDisabilities(setDisabilities, setFetcherror);
  getAllMarriageTypes(setMarriageTypes, setFetcherror);
  getAllEmploymentSectors(setEmploymentSectors, setFetcherror);
  getAllEmploymentStatuses(setEmploymentStatuses, setFetcherror);
  getAllZones(setZones, setFetcherror);

  
}, []);

useEffect(() => {
  if (selectedCountry?.id) {
    getCountryRegions(setRegions, setFetcherror, selectedCountry.id);
  }
}, [selectedCountry]);

useEffect(() => {
  if (selectedRegion?.id) {
    getRegionDistricts(setDistricts, setFetcherror, selectedRegion.id);
  }
}, [selectedRegion]);

useEffect(() => {
  if (selectedDistrict?.id) {
    getDistrictWards(setWards, setFetcherror, selectedDistrict.id);
  }
}, [selectedDistrict]);
  
useEffect(() => {
  if (selectedBroadCategory?.id) {
    getBroadCategoryCategories(setWards, setFetcherror, selectedBroadCategory.id);
  }
}, [selectedBroadCategory]);
  
useEffect(() => {
  if (selectedCategory?.id) {
    getCategorySubCategories(setWards, setFetcherror, selectedCategory.id);
  }
}, [selectedCategory]);
  
useEffect(() => {
  if (selectedBroadCategory?.id) {
    getBroadCategoryRights(setWards, setFetcherror, selectedBroadCategory.id);
  }
}, [selectedBroadCategory]);
  
  

const handleOnEditSelect = (tabledata) => {
  
  

  const editSex = [{ id: 1, name: "MALE", namesw: "KIUME" }, { id: 2, name: "FEMALE", namesw: "KIKE" }].find(
    (item) => item.name === tabledata?.sexreporter
  );

  const editSexVictim = [{ id: 1, name: "MALE", namesw: "KIUME" }, { id: 2, name: "FEMALE", namesw: "KIKE" }].find(
    (item) => item.name === tabledata?.sexvictim
  );
  const editSexPapetrator = [{ id: 1, name: "MALE", namesw: "KIUME" }, { id: 2, name: "FEMALE", namesw: "KIKE" }].find(
    (item) => item.name === tabledata?.sexperpetrator
  );
  setSelectedSexReporter(editSex);
  setSelectSetSexVictim(editSexVictim);
  setSelectedSexPerpetrator(editSexPapetrator);

  const editEducation = educationLevels.find((item) => item.name === tabledata?.educationlevelvictim)
  setESelectedEducationLevelVictim(editEducation);
  const editReligion = religions.find((item) => item.name === tabledata?.religionvictim)
  setSelectedReligionVictim(editReligion);
  const editTribe = tribes.find((item) => item.name === tabledata?.tribevictim)
  setSelectedTribeVictim(editTribe);
  const editMaritalStatus = maritalStatuses.find((item) => item.name === tabledata?.maritalstatusvictim)
  setSelectedMaritalStatusVictim(editMaritalStatus);
  const editEmploymentStatus = employmentStatuses.find((item) => item.name === tabledata?.employmentstatusvictim)
  setSelectedEmploymentStatusVictim(editEmploymentStatus);
  const editMarriageType = marriageTypes.find((item) => item.name === tabledata?.marriagetypevictim)
  setSelectedMarriageTypeVictim(editMarriageType);
  const editEmploymentSector = employmentSectors.find((item) => item.name === tabledata?.employmentsectorvictim)
  setSelectedEmploymentSectorVictim(editEmploymentSector);
  const editVulnerabilityType = vulnerabilities.find((item) => item.name === tabledata?.vulnerabilitytypevictim)
  setSelectedVulnerabilityVictim(editVulnerabilityType);
  const editDisability = disabilities.find((item) => item.name === tabledata?.disabilitytypevictim)
  setSelectedDisabilityVictim(editDisability);


  const editBirthDate= daysArray.find((item)=>item.stringValue=== extractIndividualDates(tabledata?.birthdayvictim)[2])
  const editBirthMonth = monthsArray.find((item) => item.stringValue === extractIndividualDates(tabledata?.birthdayvictim)[1])
  setSelectedBirthDayVictim(editBirthDate);
  setSelectedBirthMonthVictim(editBirthMonth);
  setBirthYearVictim(extractIndividualDates(tabledata?.birthdayvictim)[0])

  const editRole = roles.find((item) => item.name === tabledata?.rolereporter);
  setSelectedReporterRole(editRole);

  const editZone = zones.find((z) => z.name === tabledata.zone);
  setSelectedZone(editZone);

  setFistNameReporter(tabledata?.firstnamereporter);
  setLastNameReporter(tabledata?.lastnamereporter);
  setPhoneReporter(tabledata?.phoneporter);
  setEmailReporter(tabledata?.emailreporter);
  setIncidentDescription(tabledata?.eventdescription);
  setStreet(tabledata?.street);
  setEventDate(new Date(tabledata?.eventdate));
  setStepsTaken(tabledata?.stepstaken);
  setStepsDescription(tabledata?.stepstakendescription);
  setFistNameVictim(tabledata?.firstnamevictim);
  setMiddleNameVictim(tabledata?.middlenamevictim);
  setLastNameVictim(tabledata?.lastnamevictim);
  setPhoneVictim(tabledata?.phonevictim)
  setChildrenVictim(tabledata?.childrenvictim)
  setIsVictimVulnerable(tabledata?.vulnerabilityvictim);
  setFullNamePerpetrator(tabledata?.fullnameperpetrator);
  setPhonePerpetrator(tabledata?.phoneperpetrator);
  setRelationship(tabledata?.relationshipperpetrator)
  setAssitanceDescription(tabledata?.assistancedescription);
  setAssitanceNeeded(tabledata?.assistanceneded)
  setValidity(tabledata?.isvalid)


  



  const editCountry = countries.find((item) => item.name === tabledata?.country);
  setSelectedCountry(editCountry);

  const tempRegion = tabledata?.region;
  const tempDistrict = tabledata?.district;
  const tempWard = tabledata?.ward;

  getCountryRegions((fetchedRegions) => {
    setRegions(fetchedRegions);
    const editRegion = fetchedRegions.find((item) => item.name === tempRegion);
    setSelectedRegion(editRegion);

    // Fetch districts after region is selected
    getRegionDistricts((fetchedDistricts) => {
      setDistricts(fetchedDistricts);
      const editDistrict = fetchedDistricts.find((item) => item.name === tempDistrict);
      setSelectedDistrict(editDistrict);

      // Fetch wards after district is selected
      getDistrictWards((fetchedWards) => {
        setWards(fetchedWards);
        const editWard = fetchedWards.find((item) => item.name === tempWard);
        setSelectedWard(editWard);
      }, setFetcherror, editDistrict?.id);
    }, setFetcherror, editRegion?.id);
  }, setFetcherror, editCountry?.id);



  
  const tempBroadCategory =tabledata?.broadcategory
  const tempCategory =tabledata?.category
  const tempRight =tabledata?.right
  const tempSubCategory = tabledata?.subcategory

  const editBroadCategory = broadCategories.find((item) => item.name === tempBroadCategory);
  setSelectedBroadCategory(editBroadCategory);
  
  getBroadCategoryCategories((fetchedCategories) => {
    setCategories(fetchedCategories);
    const editCategory = fetchedCategories.find((item) => item.name === tempCategory);
    setSelectedCategory(editCategory);

    getCategorySubCategories((fetchedSubCategories) => {
      setSubCategories(fetchedSubCategories);
      const editSubCategory = fetchedSubCategories.find((item) => item.name === tempSubCategory);
      setSelectedSubCategory(editSubCategory);

    }, setFetcherror, editCategory?.id);
  }, setFetcherror, editBroadCategory?.id);


  getBroadCategoryRights((fetchedRights) => {
    setRights(fetchedRights);
    const editRight = fetchedRights.find((item) => item.name === tempRight);
    setSelectedRight(editRight);
  },setFetcherror, editBroadCategory?.id);

};


// const handleOnDiscardSelected = tabledata => handleOnEditSelect({ ...tabledata, isdiscarded: true });

 
  const finalrolesArray = roles.filter((item) => item?.name !== "Admin");
  
  const handleSelectFile = (event) => {
      setFiles(event.files)
  }

  const handleRemoveFile = (event) => {
    const newFilesArray = files?.filter((xfile) => xfile.name !== event?.file?.name);
    setFiles(newFilesArray);
 }
  
  const handleFileUpload = (event) => {
    fileUploadRef.current.clear();
  };





  const newIncidentTitle = incidentTitle ? incidentTitle : null
  const [commentDialogVisible, setCommentDialogVisible] = useState(false);
  const [comments, setComments] = useState([]);


  const [errors, setErrors] = useState({});
 
  const panelHeader = `INCIDENT - ${ICNrowData?.incidentnumber || ""}`
  
  

  useEffect(() => { getAllComments(setComments, setFetcherror, ICNrowData?.id, true, false) }, [])
  useEffect(() => { getAllResponses(setResponses,setFetcherror,ICNrowData?.id,true,false)},[])

const toProperCase = (textValue) => { 
  const newtextValue = textValue[0].toUpperCase() + textValue.substring(1).toLowerCase();
  return newtextValue;
}
 
  
const customizedMarker = (item) => {
  return (
      <span className="flex w-2rem h-2rem align-items-center justify-content-center text-white border-circle z-1 shadow-1" style={{ backgroundColor: item==="responses" ? '#1E4376' : '#607D8B' }}>
          <i className="pi pi-check"></i>,
      </span>
  );
};

  return (
    

    <div className="card">
        
      <Panel header={panelHeader} className="pt-4 w-2">
        
        <div className='flex flex-row justify-content-center'>
          <div style={{width:"60%"}} className='text-15px'> 
            <div className='mt-6'>
                <Divider align="start"  type='solid' severity="secondary" style={{ color: "black", width: '100%'}}>
                  <span className="p-tag text-xs mx-2 bg-white text-primary">
                  <i className="pi pi-user" style={{ fontSize: '0.7rem', marginRight: '0.5rem' }}></i>
                    Reporter Profile</span>
                </Divider>
              </div>
            <div className='pl-4 flex flex-row justify-content-between'>
              <div>
                <div className='mb-2'>Name: <span className='font-bold'>{ICNrowData?.firstnamereporter || ""}</span> <span className='font-bold'>{ICNrowData?.lastnamereporter || ""}</span></div>
                <div>Sex: <span className='font-bold'>{ICNrowData?.sexreporter || ""}</span> </div>
               </div>
                
              <div>
                <div className='mb-2' >Phone: <span className='font-bold'>{ICNrowData?.phoneporter || ""}</span> </div>
                <div>Role: <span className='font-bold'>{ICNrowData?.rolereporter || ""}</span> </div>
              </div>
                
              </div>


              <div className='mt-6'>
                      <Divider align="start" type='solid' style={{ color: "black", width: '100%' }}>
                        <span className="p-tag text-xs mx-2 bg-white text-primary">
                        <i className="pi pi-envelope" style={{ fontSize: '0.7rem', marginRight: '0.5rem' }}></i>
                          Incident Details</span>
                      </Divider>
              </div>
              <div className='pl-4 mb-3 w-full surface-ground-custom border-round-lg p-3'><span>{ICNrowData?.eventdescription || ""}</span></div>
            
                 <div className='flex flex-row justify-content-between pl-4'>
                  <div>
                  <div className='text-color-secondary mb-2 '><span>Region:</span> <span className='font-bold'>{ICNrowData?.region || ""}</span></div>
                          <div className='text-color-secondary mb-2'><span>District:</span> <span className='font-bold'>{toProperCase(ICNrowData?.district || "")}</span></div>
                          <div className='text-color-secondary'><span>Ward:</span> <span className='font-bold'>{toProperCase(ICNrowData?.ward || "")}</span></div>
                  </div>
                  <div>
                <div className='mt-2 text-xs' ><span><Tag severity="success" value={ICNrowData?.isprocessed ? "Processed" : "Unprocessed"}></Tag></span> { ICNrowData?.isprocessed && <span><Tag severity={ICNrowData?.isvalid ? "success" : "danger"} value={ICNrowData?.isvalid ? "Valid" : "Invalid"}></Tag></span>} </div>
                  <div className='mt-2 text-sm'>{formatDateTime(ICNrowData?.createdAt || "")}</div>
                  </div>  
                </div>

                

                <div className='mt-6'>
                        <Divider align="start" type='solid' style={{ color: "black", width: '100%' }}>
                          <span className="p-tag text-xs mx-2 bg-white text-primary">
                          <i className="pi pi-ticket" style={{ fontSize: '0.7rem', marginRight: '0.5rem' }}></i>
                            Incident Cetegorization</span>
                        </Divider>
                </div>
                <div className='pl-4'>
                    <div className='flex flex-row justify-content-between'>
                      <div>
                          <div className='mb-2'>Broad Category: <span className='font-bold'>{ICNrowData?.broadcategory || ""}</span></div>
                          <div >Category: <span className='font-bold'>{ICNrowData?.category || ""}</span> </div>
                      </div>
                        <div>
                          <div className='mb-2'>Sub Category: <span className='font-bold'>{ICNrowData?.subcategory || ""}</span> </div>
                          <div>Right Violated: <span className='font-bold'>{ICNrowData?.right || ""}</span> </div>
                       </div>
                    </div>
              
                    <div className='mt-6 mb-2 text-center'>Steps Taken</div>
                    <div  className='font-bold  w-full surface-ground-custom border-round-lg p-3'>{ICNrowData?.stepstakendescription || ""}</div>
                </div>


                <div className='mt-8'>
                        <Divider align="start" type='solid' style={{ color: "black", width: '100%' }}>
                          <span className="p-tag text-xs mx-2 bg-white text-primary">
                          <i className="pi pi-user" style={{ fontSize: '0.7rem', marginRight: '0.5rem' }}></i>
                            Profile of the Victim</span>
                        </Divider>
                </div>
                <div className='pl-4 flex flex-row justify-content-between'>
                    <div><div className='mb-2'>Name: <span className='font-bold'>{ICNrowData?.firstnamevictim || ""}</span> <span className='font-bold'>{ICNrowData?.lastnamevictim || ""}</span></div>
                        <div className='mb-2'>Sex: <span className='font-bold'>{ICNrowData?.sexvictim || ""}</span> </div>
                        <div className='mb-2'>Phone: <span className='font-bold'>{ICNrowData?.phonevictim || ""}</span> </div>
                        <div className='mb-2'>Birthday: <span className='font-bold'>{ICNrowData?.birthdayvictim || ""}</span> </div>
                        <div className='mb-2'>Education: <span className='font-bold'>{ICNrowData?.educationlevelvictim || ""}</span> </div>
                        <div className='mb-2'>Religion: <span className='font-bold'>{ICNrowData?.religionvictim || ""}</span> </div>
                      <div>Tribe: <span className='font-bold'>{ICNrowData?.tribevictim || ""}</span> </div>
                    </div>
                    <div> <div className='mb-2'>Children: <span className='font-bold'>{ICNrowData?.childrenvictim || ""}</span> </div>
                        <div className='mb-2'>Marital Status: <span className='font-bold'>{ICNrowData?.maritalstatusvictim || ""}</span> </div>
                        <div className='mb-2'>Marriage Type: <span className='font-bold'>{ICNrowData?.marriagetypevictim || ""}</span> </div>
                        <div className='mb-2'>Employment Status: <span className='font-bold'>{ICNrowData?.employmentstatusvictim || ""}</span> </div>
                        <div className='mb-2'>Employment Sector: <span className='font-bold'>{ICNrowData?.employmentsectorvictim || ""}</span> </div>
                        <div className='mb-2'>Vulnerability: <span className='font-bold'>{ICNrowData?.vulnerabilitytypevictim ? ICNrowData?.vulnerabilitytypevictim : ""}</span> </div>
                      <div>Disability: <span className='font-bold'>{ICNrowData?.disabilitytypevictim || ""}</span> </div>
                    </div>
                  </div>

{/* 
                  <div className='my-6'>
                          <Divider align="start" type='solid' style={{ color: "black", width: '100%' }}>
                          </Divider>
                  </div> */}
                  <div className='mt-8'>
                          <Divider align="start" type='solid' style={{ color: "black", width: '100%' }}>
                            <span className="p-tag text-xs mx-2 bg-white text-primary">
                            <i className="pi pi-user" style={{ fontSize: '0.7rem', marginRight: '0.5rem' }}></i>
                              Papetrator  and Other Details</span>
                          </Divider>
                   </div>
            
                  <div className='pl-4'>
                          <div className='flex flex-row justify-content-between'>
                            <div>
                                <div className='mb-2'>Full Name: <span className='font-bold'>{ICNrowData?.fullnameperpetrator || ""}</span></div>
                                <div >Phone: <span className='font-bold'>{ICNrowData?.phoneperpetrator || ""}</span> </div>
                            </div>
                              <div>
                                <div className='mb-2'>Sex: <span className='font-bold'>{ICNrowData?.sexperpetrator || ""}</span> </div>
                                <div>Relationship With Victim: <span className='font-bold'>{ICNrowData?.relationshipperpetrator || ""}</span> </div>
                            </div>
                          </div>
                    
                          <div className='mt-6 mb-2 text-center'>Assistance Needed</div>
                          <div  className='font-bold  w-full surface-ground-custom border-round-lg p-3'>{ICNrowData?.assistancedescription || ""}</div>
                    </div>
              

                </div>
      
          <div className="pl-7" style= {(monitorinitiated && ICNrowData?.isprocessed) ? { width: "40%" }:{ width: "40%" }}>
            <div className='flex flex-row justify-content-end'>
              <div className='flex flex-row justify-content-end w-6'>
                
                    <Button
                    icon="pi pi-comments"
                    outlined
                    iconPos="right"
                    className="p-1 text-xs"
                    tooltip='Comment'
                    tooltipOptions={{ position: 'top',className: 'custom-tooltip' }} 
                  onClick={() => {
                    if(!monitorinitiated){
                      setUpdateSelectorVisible(true);
                    }else{
                      setCommentDialogVisible(true);
                    }
                  }}
                    />
                    <Button
                    icon="pi pi-upload"
                    outlined
                    iconPos="right"
                    className="p-1 text-xs ml-2"
                    tooltip='Upload Files'
                    tooltipOptions={{ position: 'top',className: 'custom-tooltip' }} 
                    onClick={() => {}}
                />
                {(!monitorinitiated && ICNrowData?.isprocessed) && 
                      <>
                      <Button
                        icon="pi pi-file-edit"
                        outlined
                        iconPos="right"
                        className="ml-2 p-1 text-xs"
                        tooltip='Edit'
                        disabled={iconsdisabled }
                        tooltipOptions={{ position: 'top',className: 'custom-tooltip' }}
                        onClick={() => { setEditDialogVisible(true); handleOnEditSelect(ICNrowData); }}
                        />
                        <Button
                        icon="pi pi-trash"
                        outlined
                        iconPos="right"
                        className="ml-2 p-1 text-xs  text-red-700"
                        tooltip='Discard'
                        disabled={iconsdisabled }
                        tooltipOptions={{ position: 'top',className: 'custom-tooltip'}}
                        onClick={() => { setDiscardDialogVisible(true); }}
                        />
                      </>
                }

                {(!monitorinitiated && !ICNrowData?.isprocessed) &&
                  <>
                  <Button
                        icon="pi pi-file-edit"
                        outlined
                        iconPos="right"
                        className="ml-2 p-1 text-xs"
                        tooltip='Edit'
                        disabled={iconsdisabled }
                        tooltipOptions={{ position: 'top',className: 'custom-tooltip' }}
                        onClick={() => { setEditDialogVisible(true); handleOnEditSelect(ICNrowData); }}
                        />
                  </>
                }
                    
                <Button
                  icon="pi pi-home"
                  outlined
                  iconPos="right"
                  className="ml-2 p-1 text-xs"
                  tooltip='Home'
                  tooltipOptions={{ position: 'top', className: 'custom-tooltip'} }
                  onClick={() => { setViewDialogVisible(false); setEditDialogVisible(false)}}
                    />   
              </div>

              
            </div>
            <div className='mt-3'>
                          <Divider align="start" type='solid' style={{ color: "black", width: '100%' }}>
                            <span className="p-tag text-xs mx-2 bg-white text-primary">
                            <i className="pi pi-file" style={{ fontSize: '0.7rem', marginRight: '0.5rem', paddin:'0' }}></i>
                              Incident Files</span>
                          </Divider>
            </div>
            <div className='w-full surface-ground-custom border-round-lg p-3  mt-0'>
              <Card className='px-4'>
               
                {ICNrowData?.attachments?.map((item,index ) => (<>
                  
                      <div key={index}>
                    
                      <a href={ `${API_URL}/fsattachements/${item?.uri}`} target="_blank" rel="noopener noreferrer" className='no-underline text-primary '>
                        <span><i className="pi pi-file-pdf" style={{ fontSize: '0.7rem', marginRight: '0.5rem' }}></i></span>
                        <span className='font-bold'>{`Attachement ${index+1}`}</span>
                      </a>
                    </div>

                  </>))} 
              </Card>
              
            </div>

            
            <div className='flex flex-column justify-content-between'>
              
                <div>
                  <div className='mt-3'>
                              <Divider align="start" type='solid' style={{ color: "black", width: '100%' }}>
                                <span className="p-tag text-xs mx-2 bg-white text-primary">
                                <i className="pi pi-calendar" style={{ fontSize: '0.7rem', marginRight: '0.5rem' }}></i>
                                  Incident Follow Ups</span>
                              </Divider>
                  </div>
                  <div className='w-full surface-ground-custom border-round-lg px-3 py-4  mt-0 followups'>

                    <Timeline value={comments} align="left" className="" marker={customizedMarker} opposite=""
                      content={(item) => (
                        <div className='mb-4 '>
                          <Card className='w-full'>
                            
                            <div className="text-bold flex flex-row, justify-content-between" ><span className="text-white px-2 py-1 text-xs border-round-sm" style={{ backgroundColor: '#607D8B', color: "FFFFFF" }}>{item.status}</span> <span style={{ color: "#000000",fontSize:"10px" }}>{item.isprocessed ?"Valid":"Pending" } </span></div>
                            <div className='my-2 text-14px '>{item.content}</div>
                            <div className="flex flex-row justify-content-between">
                              <div className="font-bold"><span className='text-xs'>By:{item?.fromname }</span> </div>
                                  <div><span className='text-xs'>{formatDateTime(item.createdAt || "")}</span></div>
                            </div>
                          </Card>
                        </div>
                      )}>
                    </Timeline>
                  </div>
                </div>




                <div>
                <div className='mt-3'>
                              <Divider align="start" type='solid' style={{ color: "black", width: '100%' }}>
                                <span className="p-tag text-xs mx-2 bg-white text-primary">
                                <i className="pi pi-calendar" style={{ fontSize: '0.7rem', marginRight: '0.5rem' }}></i>
                                  Incident Responses</span>
                              </Divider>
                  </div>
                  <div className='w-full surface-ground-custom border-round-lg px-3 py-4  mt-0 followups'>

                    <Timeline value={responses} align="left" className="" marker={customizedMarker("responses")} opposite=""
                      content={(item) => (
                        <div className='mb-4 '>
                          <Card className='w-full'>
                            
                            <div className="text-bold flex flex-row, justify-content-between" ><span className="text-white px-2 py-1 text-xs border-round-sm" style={{ backgroundColor: '#1E4376', color: "FFFFFF" }}>{item.status}</span> <span style={{ color: "#000000",fontSize:"10px" }}>{item.isprocessed ?"Valid":"Pending" } </span></div>
                            <div className='my-2 text-14px '>{item.content}</div>
                            <div className="flex flex-row justify-content-between">
                              <div className="font-bold"><span className='text-xs'>By:{item?.fromname }</span> </div>
                                  <div><span className='text-xs'>{formatDateTime(item.createdAt || "")}</span></div>
                            </div>
                          </Card>
                        </div>
                      )}>
                    </Timeline>
                  </div>

                </div>
                
            </div> 
          </div>
          
          {commentDialogVisible && <CommentForm
            commentDialogVisible={commentDialogVisible}
            setCommentDialogVisible={setCommentDialogVisible}
            incident_id={ICNrowData?.id}
            setFetcherror={setFetcherror}
            handleAllToasts={handleAllToasts}
            setComments={setComments }
          />}

          {responseDialogVisible && <ResponseForm
            responseDialogVisible={responseDialogVisible}
            setResponseDialogVisible={setResponseDialogVisible}
            incident_id={ICNrowData?.id}
            setFetcherror={setFetcherror}
            handleAllToasts={handleAllToasts}
            setResponses={setResponses}
          />}
          
          <Dialog visible={updateSelectorVisible} modal header="Incident Updates" headerClassName='mb-0 pb-0' style={{ width: '20rem', padding: '.2rem' }} onHide={() => setUpdateSelectorVisible(false)}>
            <Panel>
              <div className='flex flex-row justify-content-between mt-2'>
                <Button icon="pi pi-building"
                  outlined
                  className='p-1 px-2 text-xs'
                  label='Comment'
                  onClick={() => setCommentDialogVisible(true)} />
                <Button
                  icon="pi pi-check"
                  outlined
                  className='p-1 px-2 text-xs'
                  label='Respond'
                  onClick={() => setResponseDialogVisible(true)} />
              </div>
            </Panel>
          </Dialog>

          <Dialog visible={discardDialogVisible} modal header="Discard Incident" headerClassName='mb-0 pb-0' style={{ width: '20rem', padding: '.2rem' }} onHide={() => setDiscardDialogVisible(false)}>
            <Panel>
              <div className='flex flex-row justify-content-between mt-2'>
                <Button icon="pi pi-times"
                  outlined
                  className='p-1 px-2 text-xs'
                  label='No'
                  onClick={() => setDiscardDialogVisible(false)} />
                <Button
                  icon="pi pi-check"
                  outlined
                  className='p-1 px-2 text-xs'
                  label='Yes'
                  onClick={() => {
                    setDiscardDialogVisible(false);
                    // handleOnDiscardSelected(ICNrowData);
                  }} />
              </div>
            </Panel>
          </Dialog>

         

          <Dialog visible={editDialogVisible} modal header={EditDialogHeader} headerClassName='mb-0 pb-0' style={{ width: '80rem' }} onHide={() => setEditDialogVisible(false)}>
          <IncidentForm
              fistNameReporter = { fistNameReporter }          setFistNameReporter = { setFistNameReporter }
              lastNameReporter = { lastNameReporter }          setLastNameReporter = { setLastNameReporter }
              selectedReporterRole = {selectedReporterRole}    setSelectedReporterRole = {setSelectedReporterRole}
              phoneReporter = {phoneReporter}                  setPhoneReporter = {setPhoneReporter}
              emailReporter = {emailReporter}                  setEmailReporter = {setEmailReporter}
              selectedSexReporter = {selectedSexReporter}      setSelectedSexReporter = {setSelectedSexReporter}
              incidentDescription = {incidentDescription}      setIncidentDescription = {setIncidentDescription}
              selectedCountry = {selectedCountry}              setSelectedCountry = {setSelectedCountry}
              selectedRegion = {selectedRegion}                setSelectedRegion = {setSelectedRegion}
              selectedDistrict = {selectedDistrict}            setSelectedDistrict = {setSelectedDistrict}
              selectedWard = {selectedWard}                    setSelectedWard = {setSelectedWard}
              street = {street}                                setStreet = {setStreet}
              eventDate = {eventDate}                          setEventDate = {setEventDate}
              selectedBroadCategory = {selectedBroadCategory}  setSelectedBroadCategory = {setSelectedBroadCategory}
              selectedCategory = {selectedCategory}            setSelectedCategory = {setSelectedCategory}
              selectedSubCategory = {selectedSubCategory}      setSelectedSubCategory = {setSelectedSubCategory}
              selectedRight = {selectedRight}                  setSelectedRight = {setSelectedRight}
              stepsTaken = {stepsTaken}                        setStepsTaken = {setStepsTaken}
              stepsDescription = {stepsDescription}            setStepsDescription = {setStepsDescription}
                        
              fistNameVictim = {fistNameVictim}                setFistNameVictim = {setFistNameVictim}
              middleNameVictim = {middleNameVictim}            setMiddleNameVictim = {setMiddleNameVictim}
              lastNameVictim = {lastNameVictim}                setLastNameVictim = {setLastNameVictim}
              selectedSexVictim = {selectedSexVictim}          setSelectSetSexVictim = {setSelectSetSexVictim}
              selectedBirthDayVictim = {selectedBirthDayVictim} setSelectedBirthDayVictim = {setSelectedBirthDayVictim}
              selectedBirthMonthVictim = {selectedBirthMonthVictim} setSelectedBirthMonthVictim = {setSelectedBirthMonthVictim}
              birthYearVictim = {birthYearVictim}              setBirthYearVictim = {setBirthYearVictim}
              phoneVictim = {phoneVictim}                      setPhoneVictim = {setPhoneVictim}
              selectedEducationLevelVictim = {selectedEducationLevelVictim} setESelectedEducationLevelVictim = {setESelectedEducationLevelVictim}
              selectedReligionVictim = {selectedReligionVictim} setSelectedReligionVictim = {setSelectedReligionVictim}
              selectedTribeVictim = {selectedTribeVictim}       setSelectedTribeVictim = {setSelectedTribeVictim}
              childrenVictim = {childrenVictim}                 setChildrenVictim = {setChildrenVictim}
              selectedMaritalStatusVictim = {selectedMaritalStatusVictim} setSelectedMaritalStatusVictim = {setSelectedMaritalStatusVictim}
              selectedMarriageTypeVictim = {selectedMarriageTypeVictim} setSelectedMarriageTypeVictim = {setSelectedMarriageTypeVictim}
              selectedEmploymentStatusVictim = {selectedEmploymentStatusVictim} setSelectedEmploymentStatusVictim = {setSelectedEmploymentStatusVictim}
              selectedEmploymentSectorVictim = {selectedEmploymentSectorVictim} setSelectedEmploymentSectorVictim = {setSelectedEmploymentSectorVictim}
              isVictimVulnerable = {isVictimVulnerable}         setIsVictimVulnerable = {setIsVictimVulnerable}
              selectedVulnerabilityVictim = {selectedVulnerabilityVictim} setSelectedVulnerabilityVictim = {setSelectedVulnerabilityVictim}
              isDisabled = {isDisabled}                         setIsDisabled = {setIsDisabled}
              selectedDisabilityVictim = {selectedDisabilityVictim} setSelectedDisabilityVictim = {setSelectedDisabilityVictim}
              fullNamePerpetrator = {fullNamePerpetrator}       setFullNamePerpetrator = {setFullNamePerpetrator}
              selectedSexPerpetrator = {selectedSexPerpetrator} setSelectedSexPerpetrator = {setSelectedSexPerpetrator}
              phonePerpetrator = {phonePerpetrator}             setPhonePerpetrator = {setPhonePerpetrator}
              relationship = {relationship}                     setRelationship = {setRelationship}
              assitanceNeeded = {assitanceNeeded}               setAssitanceNeeded = {setAssitanceNeeded}
              assitanceDescription = {assitanceDescription}     setAssitanceDescription = {setAssitanceDescription}
              setFetcherror = {setFetcherror}                   tribes = {tribes}     
              handleFileUpload = {handleFileUpload}
                  hadleSubmit = {hadleSubmit}
              finalrolesArray = {finalrolesArray}               getCountryRegions = {getCountryRegions}
              setRegions = {setRegions}                         countries = {countries}
              getRegionDistricts = {getRegionDistricts}         setDistricts = {setDistricts}
              regions = {regions}                               getDistrictWards = {getDistrictWards}
              setWards = {setWards}                             districts = {districts}
              wards = {wards}                                   getBroadCategoryCategories = {getBroadCategoryCategories}
              setCategories = {setCategories}                   getBroadCategoryRights = {getBroadCategoryRights}
              setRights = {setRights}                           broadCategories = {broadCategories}
              getCategorySubCategories = {getCategorySubCategories} setSubCategories = {setSubCategories}
              categories = {categories}                         subCategories = {subCategories}
              rights = {rights}                                 daysArray = {daysArray}
              monthsArray = {monthsArray}                       educationLevels = {educationLevels}
              religions = {religions}                           maritalStatuses = {maritalStatuses}
              employmentStatuses = {employmentStatuses}         vulnerabilities = {vulnerabilities}
              marriageTypes = {marriageTypes}                   employmentSectors = {employmentSectors}
              disabilities = {disabilities}                     fileUploadRef = {fileUploadRef}
               handleSelectFile={handleSelectFile} handleRemoveFile={handleRemoveFile}
               validity={validity} setValidity={setValidity}
              monitorinitiated={monitorinitiated}
              setSelectedZone={setSelectedZone}
              zones={ zones}
              
              />

               
        </Dialog>

        </div>
        
            
        </Panel>
      </div>
  )
}

export default IncidentViewForm